import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { REDIRECT_KEY_STORAGE } from '~/constants';
import useAuth from '~/contexts/AuthProvider';
import i18n from '~/lang';

export function useRequireAuthentication() {
  const { authenticated, initialized, login, logout } = useAuth();
  const location = useLocation();

  const currentRoute = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (!initialized || authenticated) return;
    sessionStorage.setItem(REDIRECT_KEY_STORAGE, currentRoute);
    void login({ locale: i18n.resolvedLanguage });
  }, [authenticated, initialized, login, currentRoute]);

  const loginAgain = useCallback(async () => {
    sessionStorage.setItem(REDIRECT_KEY_STORAGE, currentRoute);
    try {
      await logout({ logoutMethod: 'POST', redirectUri: `${window.location.origin}/oauth` });
    } catch {
      await logout({ logoutMethod: 'GET', redirectUri: `${window.location.origin}/oauth` });
    }
  }, [logout, currentRoute]);

  return { currentRoute, loginAgain };
}
